var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f5ac7334631692f32f57cb74a928446710a8aae3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-headlinker@martinratinaud"]={id:"f5ac7334631692f32f57cb74a928446710a8aae3"};
      